module.exports = __webpack_public_path__ + "static/media/wave.7c692abe.svg";